import React from 'react';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../config/Translate";
import { VoiceRecorder } from 'react-voice-recorder-player';
import {withStyles} from "@material-ui/core/styles";
import {Styles} from "../../../config/design/styles";
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import TextField from "@material-ui/core/TextField/TextField";
import LoadingButton from "../../components/elements/LoadingButton";
import {withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import AppAnimate from "../../components/AppAnimate";
import {FormLabel} from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Container from "@material-ui/core/Container/Container";
import {CheckBoxTwoTone, InfoOutlined, PersonRounded} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography/Typography";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ChooseDate from "../../components/elements/ChooseDate";
import SubTitleLight from "../../components/elements/SubTitleLight";
import Button from "@material-ui/core/Button/Button";
import BusinessRoundedIcon from "@material-ui/icons/BusinessRounded";
import CheckRoundIcon from "@material-ui/icons/CheckRounded";
import Done from '../../../files/img/done.png';
import formIMG from "../../../files/img/form.png";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Alert from "@material-ui/lab/Alert/Alert";

class submitContactDetails extends React.Component {
    classes = this.props.classes;
    state = {
        audio:null,
        fields: {
            name: '',
            nickname: '',
            mobile:'',
            gender:'male',
            status:'pending_for_call',
            first_impression_at:null,
            description:"",
            type:'person',
            melli_code:'',
            address:'',
            email:'',
            birth_date:null,
            father_name:'',
            phone_number:"",
            postal_code:'',
            company_name:'',
            company_national_code:'',
            company_register_number:'',
            company_financial_number:'',
            company_ceo:'',
            company_ceo_mobile:'',
        },
        errors:[],
        person_id:this.props.match.params.id,
        person:null,
        loading:true,
        SubmitLoading:false,
        done:false,
        has_invoice:0,
    }
    componentDidMount() {
        this.loadData();
    }
    async loadData(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/person/get-by-unique/${this.state.person_id}`, config)
            .then(response => {
                this.setState({
                    fields: {
                        name: !!response.data.name ? response.data.name : '',
                        mobile:!!response.data.mobile ? response.data.mobile : '',
                        type:!!response.data.type ? response.data.type : '',
                        melli_code:!!response.data.melli_code ? response.data.melli_code : '',
                        address:!!response.data.address ? response.data.address : '',
                        email:!!response.data.email ? response.data.email :'',
                        birth_date:!!response.data.birth_date ? response.data.birth_date : '',
                        phone_number:!!response.data.phone_number ? response.data.phone_number : '',
                        postal_code:!!response.data.postal_code ? response.data.postal_code : '',
                        company_name:!!response.data.company_name ? response.data.company_name : '',
                        company_national_code:!!response.data.company_national_code ? response.data.company_national_code :'',
                        company_register_number:!!response.data.company_register_number ? response.data.company_register_number : '',
                        company_financial_number:!!response.data.company_financial_number ? response.data.company_financial_number : '',
                        company_ceo:!!response.data.company_ceo ? response.data.company_ceo :'',
                        company_ceo_mobile:!!response.data.company_ceo_mobile ? response.data.company_ceo_mobile : '',
                    },
                    person:response.data,
                    has_invoice:response.data.has_invoice,
                    done:!!response.data.contract_info_done,
                    loading:false
                })

            }).catch(error => {
                this.setState({
                    loading:false
                })
            })
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        if(validator.isEmpty(fields.company_ceo)){
            formIsValid = false;
            errors['company_ceo'] = Translate.emptyField;
        }
        if(validator.isEmpty(fields.company_ceo_mobile)){
            formIsValid = false;
            errors['company_ceo_mobile'] = Translate.emptyField;
        }else if(fields.company_ceo_mobile.length < 6 || fields.company_ceo_mobile.length > 14){
            formIsValid = false;
            errors['company_ceo_mobile'] = Translate.wrongMobile;
        }
        if(validator.isEmpty(fields.melli_code)){
            formIsValid = false;
            errors['melli_code'] = Translate.emptyField;
        }
        if(validator.isEmpty(fields.email)){
            formIsValid = false;
            errors['email'] = Translate.emptyField;
        }else if(!validator.isEmail(fields.email)){
            formIsValid = false;
            errors['email'] = Translate.wrongEmail;
        }

        if(validator.isEmpty(fields.phone_number)){
            formIsValid = false;
            errors['phone_number'] = Translate.emptyField;
        }
        if(validator.isEmpty(fields.postal_code)){
            formIsValid = false;
            errors['postal_code'] = Translate.emptyField;
        }
        if(validator.isEmpty(fields.address)){
            formIsValid = false;
            errors['address'] = Translate.emptyField;
        }
        if(fields.type === "person"){
            /*if(!fields.birth_date){
                formIsValid = false;
                errors['birth_date'] = Translate.emptyField;
            }*/
        }else{
            if(validator.isEmpty(fields.company_name)){
                formIsValid = false;
                errors['company_name'] = Translate.emptyField;
            }
            if(validator.isEmpty(fields.company_register_number)){
                formIsValid = false;
                errors['company_register_number'] = Translate.emptyField;
            }
            if(validator.isEmpty(fields.company_financial_number)){
                formIsValid = false;
                errors['company_financial_number'] = Translate.emptyField;
            }
            if(validator.isEmpty(fields.company_national_code)){
                formIsValid = false;
                errors['company_national_code'] = Translate.emptyField;
            }
        }

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,person_id,has_invoice} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('nickname', fields.nickname);
        data.append('mobile', fields.mobile);
        data.append('gender', fields.gender);
        data.append('status', fields.status);
        data.append('first_impression_at', fields.first_impression_at);
        data.append('description', fields.description);
        data.append('type', fields.type);
        data.append('melli_code', fields.melli_code);
        data.append('address', fields.address);
        data.append('email', fields.email);
        data.append('birth_date', fields.birth_date);
        data.append('father_name', fields.father_name);
        data.append('phone_number', fields.phone_number);
        data.append('postal_code', fields.postal_code);
        data.append('company_name', fields.company_name);
        data.append('company_national_code', fields.company_national_code);
        data.append('company_national_code', fields.company_national_code);
        data.append('company_register_number', fields.company_register_number);
        data.append('company_financial_number', fields.company_financial_number);
        data.append('company_ceo', fields.company_ceo);
        data.append('company_ceo_mobile', fields.company_ceo_mobile);
        data.append('id', person_id);
        data.append('has_invoice', !!has_invoice ? 1 : 0);


        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        axios.post(`${defaultVariabls.url}/person/make-by-user`, data, config)
            .then(response => {
                this.setState({
                    SubmitLoading:false,
                    done:true
                })
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleAudio(res){
        let file = new File([res], 'audi.wav');
        this.setState({
            audio:file
        })
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }
    handleItem(item,val){
        let {fields,errors,} = this.state;
        fields[item] = val;
        errors[item] = '';
        this.setState({
            fields,
            errors
        })

    }
    handleType(type){
        let {fields} = this.state;
        fields['type'] = type;
        this.setState({
            fields
        })
    }
    render() {
            let {SubmitLoading,fields,errors,person,loading,done,has_invoice} = this.state;
        return (
            <div className={this.classes.rootSubmit}>
                {
                    !loading &&
                    <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.submitContactDetails}>
                        <Container maxWidth='lg'>
                            <Grid container spacing={2}  justifyContent="center">
                                <Grid item xs={12}>
                                    <div className="logo-holder">
                                        <a href={`${defaultVariabls.website}`} target="_blank">
                                            <img className="logo" src={`${defaultVariabls.website}/assets/img/rayanita/logo.png`} alt="Rayanita"/>
                                        </a>
                                        <h1>{Translate.submitContactDetails}</h1>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <h2>فرم ثبت اطلاعات قرارداد</h2>
                                    <p>لطفا جهت ادامه فرایند و تدوین قرارداد اطلاعات فرم را تکمیل بفرمایید.</p>
                                    {/*<p>در صورت ثبت اطلاعات حقوقی، فاکتور رسمی لحاظ شده و ۱۰٪ ارزش افزوده محاسبه می‌گردد.</p>
                                    <p>برای اشخاص حقیقی امکان انتخاب فاکتور رسمی وجود دارد. در صورت تمایل برای دریافت فاکتور رسمی ۱۰٪ ارزش افزوده محاسبه می‌شود.</p>*/}
                                    <p>می‌توانید اطلاعات خود را به صورت شخص حقیقی و یا حقوقی تکمیل نمایید.</p>
                                    <p>قرارداد متناسب با نوع شخصیت انتخابی تنظیم می‌گردد.</p>
                                    <p>با سپاس</p>
                                    <img src={formIMG} style={{maxWidth:"100%",marginTop:10}}/>
                                </Grid>
                                <Grid item xs={12} md={1} />
                                <Grid item xs={12} md={7}>
                                    {
                                        done ?
                                            <div className="form-holder">
                                            <div className='done-holder'>
                                                <img src={Done} style={{maxWidth:150,marginBottom:20}}/>
                                                <Typography>با تشکر از شما، اطلاعات قرارداد ثبت شد!</Typography>
                                                <Button
                                                    size="small"
                                                    color="secondary"
                                                    varaint="contained"
                                                    component="a"
                                                    href={`${defaultVariabls.website}`}
                                                >
                                                    بازگشت به سایت
                                                </Button>
                                            </div>
                                            </div>
                                            :
                                            <div className="form-holder">
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:0,marginTop:5,display:"block"}} >نوع قرارداد را انتخاب نمایید:</FormLabel>
                                                        <div  style={{textAlign:"center"}}>
                                                            <Button
                                                                className={fields.type === "person" ? "active type-btn" : "type-btn"}
                                                                startIcon={<PersonRounded/>}
                                                                onClick={() => this.handleType('person')}
                                                                style={{marginLeft:10}}
                                                            >
                                                                {Translate.person}
                                                            </Button>
                                                            <Button
                                                                className={fields.type === "company" ? "active type-btn" : "type-btn"}
                                                                startIcon={<BusinessRoundedIcon/>}
                                                                onClick={() => this.handleType('company')}

                                                            >
                                                                {Translate.company}
                                                            </Button>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <FormLabel style={{marginBottom:5,marginTop:5,display:"block"}} >مشخصات خود را وارد نمایید:</FormLabel>
                                                    </Grid>
                                                    {
                                                        fields.type === "person" ?
                                                            <>
                                                                <Grid item xs={12} md={8}>
                                                                    <FormHelperText style={{display:"flex",alignItems:"center",marginBottom:10,color:"rgb(52,186,255)"}}><InfoOutlined style={{marginLeft:5,fontSize:"1rem"}}/>{Translate.mobileHint}</FormHelperText>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={fields.company_ceo_mobile}
                                                                        color="secondary"
                                                                        fullWidth
                                                                        type="number"
                                                                        label={Translate.mobile}
                                                                        name="company_ceo_mobile"
                                                                        size="small"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['company_ceo_mobile']}
                                                                        helperText={errors['company_ceo_mobile']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4} />
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={fields.company_ceo}
                                                                        color="secondary"
                                                                        fullWidth
                                                                        size="small"
                                                                        label={Translate.userName}
                                                                        name="company_ceo"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['company_ceo']}
                                                                        helperText={errors['company_ceo']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={fields.melli_code}
                                                                        fullWidth
                                                                        color="secondary"
                                                                        size="small"
                                                                        type="number"
                                                                        label={Translate.melli_code}
                                                                        name="melli_code"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['melli_code']}
                                                                        helperText={errors['melli_code']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={fields.email}
                                                                        fullWidth
                                                                        color="secondary"
                                                                        type="email"
                                                                        label={Translate.email}
                                                                        size="small"
                                                                        name="email"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['email']}
                                                                        helperText={errors['email']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <ChooseDate
                                                                        input={fields.birth_date}
                                                                        noMargin
                                                                        handleDate={(val) => this.handleItem('birth_date',val)}
                                                                        label={Translate.birth_date}
                                                                        color="secondary"
                                                                        error={errors['birth_date']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={fields.phone_number}
                                                                        fullWidth
                                                                        color="secondary"
                                                                        type="number"
                                                                        label={Translate.phone_number}
                                                                        name="phone_number"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['phone_number']}
                                                                        helperText={errors['phone_number']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} md={4}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        size="small"
                                                                        value={fields.postal_code}
                                                                        fullWidth
                                                                        type="number"
                                                                        label={Translate.postal_code}
                                                                        color="secondary"
                                                                        name="postal_code"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['postal_code']}
                                                                        helperText={errors['postal_code']}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        multiline
                                                                        minRows={2}
                                                                        value={fields.address}
                                                                        color="secondary"
                                                                        fullWidth
                                                                        size="small"
                                                                        label={Translate.address}
                                                                        name="address"
                                                                        onChange={this.handleChange.bind(this)}
                                                                        error = {!!errors['address']}
                                                                        helperText={errors['address']}
                                                                    />
                                                                </Grid>

                                                                {/*<Grid item xs={12}>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={has_invoice}
                                                                                onChange={() => this.setState({has_invoice:!!has_invoice ? 0 : 1})}
                                                                                name="has_invoice"
                                                                            />
                                                                        }
                                                                        label={Translate.has_invoice}
                                                                    />
                                                                </Grid>*/}
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    fields.type === "company" &&
                                                                    <>
                                                                        <Grid item xs={12}>
                                                                            <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >
                                                                                {Translate.companyInfo}
                                                                            </FormLabel>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.company_name}
                                                                                fullWidth
                                                                                label={Translate.company_name}
                                                                                name="company_name"
                                                                                color="secondary"
                                                                                size="small"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['company_name']}
                                                                                helperText={errors['company_name']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.company_national_code}
                                                                                fullWidth
                                                                                color="secondary"
                                                                                type="number"
                                                                                label={Translate.company_national_code}
                                                                                name="company_national_code"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                size="small"
                                                                                error = {!!errors['company_national_code']}
                                                                                helperText={errors['company_national_code']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.company_register_number}
                                                                                size="small"
                                                                                color="secondary"
                                                                                fullWidth
                                                                                type="number"
                                                                                label={Translate.company_register_number}
                                                                                name="company_register_number"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['company_register_number']}
                                                                                helperText={errors['company_register_number']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.company_financial_number}
                                                                                size="small"
                                                                                color="secondary"
                                                                                fullWidth
                                                                                type="number"
                                                                                label={Translate.company_financial_number}
                                                                                name="company_financial_number"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['company_financial_number']}
                                                                                helperText={errors['company_financial_number']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                size="small"
                                                                                value={fields.phone_number}
                                                                                fullWidth
                                                                                type="number"
                                                                                color="secondary"
                                                                                label={Translate.phone_number}
                                                                                name="phone_number"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['phone_number']}
                                                                                helperText={errors['phone_number']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                size="small"
                                                                                value={fields.postal_code}
                                                                                fullWidth
                                                                                type="number"
                                                                                label={Translate.postal_code}
                                                                                color="secondary"
                                                                                name="postal_code"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['postal_code']}
                                                                                helperText={errors['postal_code']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                multiline
                                                                                minRows={2}
                                                                                value={fields.address}
                                                                                color="secondary"
                                                                                fullWidth
                                                                                size="small"
                                                                                label={Translate.address}
                                                                                name="address"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['address']}
                                                                                helperText={errors['address']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12}>
                                                                            <FormLabel style={{marginBottom:5,marginTop:15,display:"block"}} >
                                                                                {Translate.ceoInfo}
                                                                            </FormLabel>
                                                                        </Grid>
                                                                        <Grid item xs={12} md={8}>
                                                                            <FormHelperText style={{display:"flex",alignItems:"center",marginBottom:10,color:"rgb(52,186,255)"}}><InfoOutlined style={{marginLeft:5,fontSize:"1rem"}}/>{Translate.mobileHintCompany}</FormHelperText>
                                                                            <TextField
                                                                                variant="outlined"

                                                                                value={fields.company_ceo_mobile}
                                                                                color="secondary"
                                                                                fullWidth
                                                                                label={Translate.mobile}
                                                                                name="company_ceo_mobile"
                                                                                size="small"
                                                                                type="number"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['company_ceo_mobile']}
                                                                                helperText={errors['company_ceo_mobile']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4} />
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.company_ceo}
                                                                                color="secondary"
                                                                                fullWidth
                                                                                size="small"
                                                                                label={Translate.userName}
                                                                                name="company_ceo"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['company_ceo']}
                                                                                helperText={errors['company_ceo']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.melli_code}
                                                                                fullWidth
                                                                                color="secondary"
                                                                                size="small"
                                                                                type="number"
                                                                                label={Translate.melli_code}
                                                                                placeholder={Translate.melli_code}
                                                                                name="melli_code"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['melli_code']}
                                                                                helperText={errors['melli_code']}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextField
                                                                                variant="outlined"
                                                                                value={fields.email}
                                                                                fullWidth
                                                                                color="secondary"
                                                                                type="email"
                                                                                label={Translate.email}
                                                                                size="small"
                                                                                placeholder={Translate.email}
                                                                                name="email"
                                                                                onChange={this.handleChange.bind(this)}
                                                                                error = {!!errors['email']}
                                                                                helperText={errors['email']}
                                                                            />
                                                                        </Grid>
                                                                        {/*<Grid item xs={12}>
                                                                            <Alert severity="info" icon={false} style={{backgroundColor:"rgb(155 190 255 / 94%) !important"}}>
                                                                                {Translate.has_invoice_det}
                                                                            </Alert>
                                                                        </Grid>*/}
                                                                    </>
                                                                }
                                                            </>

                                                    }
                                                    <Grid item xs={12}>
                                                        <LoadingButton
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick = {this.handleSubmit.bind(this)}
                                                            loading = {SubmitLoading}
                                                            size="large"
                                                            startIcon={<CheckRoundIcon/>}
                                                        >
                                                            {Translate.submitForm}
                                                        </LoadingButton>
                                                    </Grid>
                                                </Grid>
                                            </div>
                                    }

                                </Grid>
                            </Grid>
                        </Container>
                    </AppAnimate>
                }
            </div>

        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(submitContactDetails))));
const styles = {
    mainContainerStyle: {
        boxShadow:"none",
        margin:0,
        borderRadius:4
    },
    controllerContainerStyle: {
        background:"#001131",
        borderTop:0,
    },
    controllerStyle: {

    },
    waveContainerStyle: {
        background:"#00091a"
    }
};
